<div mat-dialog-container>
  <h1 class="flex flex-row justify-center items-center" mat-dialog-title>
    {{ data.dialogText }}
  </h1>
  <div
    class="flex flex-row justify-center items-center py-4 gap-6"
    mat-dialog-actions
    [align]="'center'"
  >
    <button mat-stroked-button (click)="onNoClick()" ariaLabel="cancel revoke">
      Cancel
    </button>
    <button
      mat-stroked-button
      [mat-dialog-close]="{ confirm: true }"
      cdkFocusInitial
      style="color: #d01d1d"
      [aria-label]="'confirm revoke'"
    >
      Yes
    </button>
  </div>
</div>
